import { render } from "./Error404View.vue?vue&type=template&id=95ae2f2c&scoped=true"
const script = {}

import "./Error404View.vue?vue&type=style&index=0&id=95ae2f2c&scoped=true&lang=css"

import exportComponent from "D:\\mnry7\\Documents\\front-saberes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95ae2f2c"]])

export default __exports__